import { Colors } from '@ab-core/colors';
import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const ComparisonContainer = styled.div`
    display: grid;
    grid-template-columns: 2fr auto 2fr auto 2fr 1fr auto;
    gap: ${SPACING.SMALL_3};
    align-items: center;
    padding: ${SPACING.SMALL_3} ${SPACING.MEDIUM};
    &.ab-compare-container-is-open {
        transform: translate(0);
    }
`;

export const Separator = styled.div`
    width: 1px;
    height: 100%;
    background: ${Colors.gray50};
`;

export const ButtonContainer = styled.div`
    grid-column-end: -2;
`;

export const IconContainer = styled.div`
    grid-column-end: -1;
    cursor: pointer;
    align-self: baseline;
`;
